import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '~/utils/redux/hooks';
import { selectPermission, selectUser } from '~/thunks/auth/authSlice';
import { canDoAction, canViewModule } from '~/utils/helper/permission';
import { setupRoute } from '~/utils/routes/setup';

type Props = {
  module?: string;
  // a specific action of the module (e.g. manageAllergy) the account must hold
  action?: string;
  page: ReactElement;
};

// Blocks a deep link to a tab the account has no `view` permission for.
const SetupTab = ({ module, action, page }: Props) => {
  const user = useAppSelector(selectUser);
  const permission = useAppSelector(selectPermission);

  const allowed = module && action ? canDoAction(user, permission, module, action) : canViewModule(user, permission, module);
  if (!allowed) {
    return <Navigate to={setupRoute.base} replace />;
  }

  return page;
};

export default SetupTab;
